export const SELECTBOX_OPTION_LABEL_CLASSNAME = 'selectbox-option-label';
